import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Grid } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import FormatCurrency from "shared/components/currency/FormatCurrency";

import {
  getUnit,
  findLineItem,
  findSection,
  findSubLineItem
} from "shared/selectors/unit";
import { has } from "lodash";
import { withRouter } from "../../helpers/withRouter";
import "./pageTotal.scss";

class PageTotal extends React.Component {
  static propTypes = {
    i18n: PropTypes.object.isRequired,
    unit: PropTypes.object.isRequired,
    isPriceOnRequest: PropTypes.bool.isRequired,
    item: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { unit, item, isPriceOnRequest } = this.props;
    return (
      <div data-component="sectionTotal">
        {this.renderSubTotal(item, isPriceOnRequest)}
        {this.renderTotal(unit, isPriceOnRequest)}
        {this.renderHints(isPriceOnRequest)}
      </div>
    );
  }

  renderTotal = (unit, isPriceOnRequest) => {
    return (
      <div className="total">
        <Grid>
          <Grid.Column width="8" className="total-text">
            <FormattedMessage
              id="buyerPortal.sections.total"
              defaultMessage="buyerPortal.sections.total"
            />
          </Grid.Column>
          <Grid.Column width="8" textAlign="right" className="total-amount">
            <FormatCurrency amount={unit.total} />
            {isPriceOnRequest ? "*" : ""}
          </Grid.Column>
        </Grid>
      </div>
    );
  };

  renderSubTotal = (item, isPriceOnRequest) => {
    if (item) {
      const amount = has(item, "totalRelative")
        ? item.totalRelative
        : item.total;
      return (
        <div className="subtotal">
          <Grid>
            <Grid.Column width="8" className="subtotal-text">
              <FormattedMessage
                id="buyerPortal.sections.subtotal"
                defaultMessage="buyerPortal.sections.subtotal"
                values={{ sectionTitle: item.title }}
              />
            </Grid.Column>
            {/* This column below contains subtotal text without VAT
                it is hidden by default
                can be shown by using the css code in this snippet: https://gitlab.com/baudigital/plano/-/snippets/2053347 */}
            <Grid.Column width="8" className="subtotal-text-without-vat">
              <FormattedMessage
                id="buyerPortal.sections.subtotalWithoutVat"
                defaultMessage="buyerPortal.sections.subtotalWithoutVat"
                values={{ sectionTitle: item.title }}
              />
            </Grid.Column>
            <Grid.Column
              width="8"
              textAlign="right"
              className="subtotal-amount"
            >
              <FormatCurrency amount={amount} />
              {isPriceOnRequest ? "*" : ""}
            </Grid.Column>
          </Grid>
        </div>
      );
    }
  };

  renderHints = isPriceOnRequest => {
    if (isPriceOnRequest) {
      return (
        <div className="hint">
          *{" "}
          <FormattedMessage
            id="buyerPortal.sections.priceOnRequestHint"
            defaultMessage="buyerPortal.sections.priceOnRequestHint"
          />
        </div>
      );
    }
  };
}

const mapStateToProps = (state, props) => {
  const { i18n } = state;
  const { sectionId, lineItemId, subLineItemId } = props.params;

  const item = [
    [subLineItemId, findSubLineItem],
    [lineItemId, findLineItem],
    [sectionId, findSection]
  ]
    .filter(e => e[0])
    .map(e => e[1](state)(e[0]))[0];
  const unit = getUnit(state);
  const { isPriceOnRequest } = unit;

  return {
    i18n,
    unit,
    item,
    isPriceOnRequest
  };
};

export default withRouter(connect(mapStateToProps)(PageTotal));
